import styles from './style.module.scss';
import { useEffect, useRef, useState } from 'react';

import DescCard from './descCard';
import VideoCard from './videoCard';

const DemoCard = ({ demoList, row }) => {
  const { demoTitle, videoUrl, posterUrl, demoDesc } = demoList;
  const OddComp = () => {
    return (
      <>
        <DescCard demoTitle={demoTitle} demoDesc={demoDesc}></DescCard>
        <VideoCard videoUrl={videoUrl} poster={posterUrl}></VideoCard>
      </>
    );
  };

  const EvenComp = () => {
    return (
      <>
        <VideoCard videoUrl={videoUrl} poster={posterUrl}></VideoCard>
        <DescCard demoTitle={demoTitle} demoDesc={demoDesc}></DescCard>
      </>
    );
  };

  const DispComp = row === 'odd' ? OddComp : EvenComp;

  return (
    <div className={styles['wrapper']}>
      <DispComp />
    </div>
  );
};

export default DemoCard;
